var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row m-0",style:(this.style),attrs:{"id":"loading"}},[_vm._m(0),(_vm.title)?_c('div',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"gifLoader",attrs:{"src":require("../../public/logo-maquillate-favicon_gif.gif"),"alt":"maquillate favicon gif"}})])
}]

export { render, staticRenderFns }